import { adminHttpClient } from '../../../../commons/adminHttpClient'

import OrderedPageFilter from '../../../../commons/orderedPageFilter'
import PagedList from '../../../../commons/PagedList'

export interface PagedReimbursementsBalances extends PagedList<ReimbursementBalanceItem> {}

export interface ReimbursementBalanceItem {
  companyUserId: string
  fullName: string
  allowanceYTD: number
  reimbursementYTD: number
  balance: number
  categoryId: number
  categoryName: string
}

const getReimbursementsBalances = (
  filter: OrderedPageFilter,
  planPeriodId: string,
): Promise<PagedReimbursementsBalances> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'fullName',
    orderDescending: true,
  }
  return adminHttpClient.get(
    `/AdminDashboard/perks/PerksReimbursementsBalance/${planPeriodId}/ReimbursementBalance`,
    filter,
  )
}

export default getReimbursementsBalances
